export const SPACING_AUTO = 'auto'

// powers-of-two spacing scale
export const SPACING_1 = '0.25rem'
export const SPACING_2 = '0.5rem'
export const SPACING_3 = '1rem'
export const SPACING_4 = '2rem'
export const SPACING_5 = '4rem'
export const SPACING_6 = '8rem'
export const SPACING_7 = '16rem'
export const SPACING_8 = '32rem'
